module.exports = __webpack_public_path__ + "media/8.c985c3dd.wav";